<template>
  <section class="order-detail-container" v-loading="isLoading">
    <div class="header">
      <p class="text">请选择查询日期</p>
      <div class="date-wrapper">
        <p class="item" @click="handleOpenPicker('start')">
          {{momentValue(startTime)}}
          <i class="iconfont icon-angeldown1"></i>
        </p>
        <span class="line">-</span>
        <p class="item" @click="handleOpenPicker('end')">
          {{momentValue(endTime)}}
          <i class="iconfont icon-angeldown1"></i>
        </p>
      </div>
    </div>
    <dl class="order-wrapper">
      <dd class="item" v-for="(list,index) in listData" :key="index">
        <div class="head" :id="momentValue(list.time)">
          <p class="date">{{momentValue(list.time)}}</p>
          <div class="statics">
            <p>累计销量：{{list.count}}</p>
            <p>累计佣金：<nr-amount :value="list.money" /></p>
          </div>
        </div>
        <ul class="order-list">
          <li class="list" v-for="(item,ind) in list.list" :key="ind">
            <div class="info-wrapper">
              <div class="img-box">
                <img :src="item.image" alt />
              </div>
              <div class="content">
                <div class="title-box">
                  <span
                    class="tag"
                    :class="['tag_'+returnTypeText(item.type, item.platform_display).type]"
                  >{{returnTypeText(item.type, item.platform_display).text}}</span>
                  <p class="title ellipsis-1">{{item.title}}</p>
                </div>
                <p class="time">{{momentValue(item.distribution_time,'HH:mm')}}</p>
              </div>
              <div>
                <div class="brokerage">
                  预估佣金：
                  <span class="price"><nr-amount :value="item.money" /></span>元
                </div>
              </div>
            </div>
            <div class="order-status">
              <p
                class="status"
                :class="[item.balance_status === '0'?'':'end']"
              >{{item.indent_status | orderStatusFilter(item.balance_status, item.indent_status_display, routeType)}}</p>
              <p class="rel-price">{{routeType == 'knowledge' ? '实际有效价格' : '预估计佣金额'}}：<nr-amount :value="item.real_price" />元</p>
            </div>
          </li>
        </ul>
      </dd>
    </dl>
    <Empty v-if="!listData.length" />

    <md-date-picker
      ref="startDatePicker"
      v-model="isStartDatePickerShow"
      type="date"
      title="开始时间"
      large-radius
      :min-date="limit.minDate"
      :max-date="limit.maxDate"
      :default-date="startTime"
      @confirm="onStartDatePickerConfirm"
      ok-text="下一步"
    ></md-date-picker>

    <md-date-picker
      ref="endDatePicker"
      v-model="isEndDatePickerShow"
      type="date"
      title="结束时间"
      large-radius
      :mask-closable="false"
      :min-date="limit.minDate"
      :max-date="limit.maxDate"
      :default-date="endTime"
      @confirm="onEndDatePickerConfirm"
      @cancel="onEndDatePickerCancel"
      cancel-text="上一步"
      ok-text="确定"
    ></md-date-picker>
  </section>
</template>

<script>
import { getUserIndentTimeArea, getDistributionIndentDetial, getXcxOrderDetail } from "@/api/distribution"
import { momentValue } from "@/utils"
import moment from 'moment'

export default {
  data() {
    return {
      routeType: null,
      isFirstLoad: true,
      isLoading: false,
      listData: [],
      limit: {
        maxDate: new Date(),
        minDate: new Date(),
      },
      startTime: null,
      endTime: null,
      selectStartDate: '', //记录选择的开始时间
      isStartDatePickerShow: false,
      isEndDatePickerShow: false,
    };
  },
  filters: {
    orderStatusFilter(indent_status, balance_status, indent_status_display, routeType) {
      switch (routeType) {
        case 'knowledge':
          let result = "";
          if (indent_status === "4") {
            if (balance_status === "0") {
              result = "待结算";
            } else {
              result = "已结算";
            }
          } else {
            switch (indent_status) {
              case "1":
                result = "可退款";
                break;
              case "2":
                result = "订单确认";
                break;
              case "3":
                result = "冻结状态";
                break;
              case "5":
                result = "已退款";
                break;
              default:
                break;
            }
          }
          return result;
        case 'physical':
          return indent_status_display
        default:
          break;
      }


    },
  },
  methods: {
    momentValue,
    async loadData() {
      this.isLoading = true;
      const params = {
        startTime: moment(this.startTime).format('YYYY-MM-DD'),
        endTime: moment(this.endTime).format('YYYY-MM-DD'),
      };
      let res
      switch (this.routeType) {
        case 'knowledge':
          res = await getDistributionIndentDetial(params)
          break;
        case 'physical':
          res = await getXcxOrderDetail(params)
          break;        
        default:
          break;
      }
      
      if (res.success) {
        this.isLoading = false
        this.listData = res.data
        let _time = this.$route.query.time;
        if (this.isFirstLoad && _time) {
          this.$nextTick(()=> {
            document.getElementById(`${_time}`).scrollIntoView()
          })
        }
        this.isFirstLoad = false
      } else {
        this.isLoading = false
        this.$toast.failed(res.message)
      }
    },
    //获取时间区间
    async loadUserIndentTimeArea() {
      let res
      switch (this.routeType) {
        case 'knowledge':
          res = await getUserIndentTimeArea()
          break;
        case 'physical':
          res = await getUserIndentTimeArea({type: 2})
          break;        
        default:
          break;
      }
      if(res.success) {
        this.limit.minDate = moment(res.data.minTime).toDate();
        this.limit.maxDate = moment(res.data.now).toDate();
      }
    },
    //确认选择开始日期
    onStartDatePickerConfirm(columnsValue) {
      this.selectStartDate = moment(this.$refs.startDatePicker.getFormatDate('yyyy-MM-dd')).toDate();
      this.isEndDatePickerShow = true;
    },
    //确认选择结束日期
    onEndDatePickerConfirm(columnsValue) {
      if (this.selectStartDate) {
        this.startTime = this.selectStartDate        
      }
      this.endTime = moment(this.$refs.endDatePicker.getFormatDate('yyyy-MM-dd')).toDate();
      if (this.startTime > this.endTime) {
        [ this.startTime, this.endTime ] = [ this.endTime, this.startTime ]
      }
      this.loadData()
    },
    //上一步
    onEndDatePickerCancel() {
      this.isStartDatePickerShow = true;
    },
    //打开开始日期选择
    handleOpenPicker(type) {
      if(this.isStartDatePickerShow || this.isEndDatePickerShow) return;

      type === 'start' ? this.isStartDatePickerShow = true : this.isEndDatePickerShow = true;
    },
    returnTypeText(types = "", platform_display = "") {
      let _type
      let text
      switch (this.routeType) {
        case 'knowledge':
          _type = types.split(",")[0],
            text = ""
          if (_type === "1") text = "课程"
          if (_type === "2") text = "小说"
          if (_type === "3") text = "漫画"
          if (_type === "24") text = "测评"   
          return {
            type: _type,
            text: text,
          }
        case 'physical':
          return {
            type: 1,
            text: platform_display,
          }
        default:
          break;
      }
    },
  },
  created() {
    const time = this.$route.query.time;
    this.routeType = this.$route.query.type
    let _time = time ? moment(time).toDate() : moment().toDate()
    this.startTime = _time;
    this.endTime = _time;

    this.loadData();
    this.loadUserIndentTimeArea();
  }
};
</script>

<style lang="scss">
$order-header-height: 84px;
.order-detail-container {
  padding-top: $order-header-height;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  position: relative;

  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: $order-header-height;
    background-color: #fff;
    z-index: 9999;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
    color: $text-color;
    font-size: 24px;

    .date-wrapper {
      display: flex;
      align-items: center;
    }
    .item {
      background-color: #f5f5f5;
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 14px 0 20px;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .line {
      display: inline-block;
      margin: 0 12px;
      color: #e8e8e8;
    }
    .iconfont {
      font-size: 23px;
      margin-left: 8px;
      position: relative;
      top: 1px;
    }
  }
  .order-wrapper {
    .head {
      padding: 35px 0 30px;
      position: sticky;
      top: calc( #{$order-header-height} - 2px);
      background-color: #f5f5f5;
      z-index: 99;
    }
    .date {
      padding: 0 30px;
      color: $heading-color;
      font-size: 32px;
      box-sizing: border-box;
      background-color: #f5f5f5;
    }
    .statics {
      margin-top: 10px;
      color: $text-color;
      font-size: 24px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;

      p {
        margin-right: 40px;
      }
    }
  }
  .order-list {
    .list {
      background-color: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      margin-bottom: 5px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .info-wrapper {
    padding: 30px 0;
    display: flex;
    border-bottom: 1px solid $border-color-base;

    .img-box {
      width: 90px;
      height: 72px;
      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .content {
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title-box {
      display: flex;
      align-items: center;

      .tag {
        flex-shrink: 0;
        font-size: 20px;
        width: 60px;
        line-height: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        background-color: transparent;
        margin-right: 2px;
        color: #fff;

        &.tag_1 {
          background-color: #ff7575;
        }
        &.tag_2 {
          background-color: #01b0ef;
        }
        &.tag_3 {
          background-color: #e98fff;
        }
        &.tag_24 {
          background-color: #88dd4b;
        }
      }
      .title {
        font-size: 26px;
        padding: 5px 0;
      }
    }
    .time {
      font-size: 22px;
      color: $text-color-secondary;
    }
    .brokerage {
      margin-left: 30px;
      display: flex;
      align-items: flex-end;
      font-size: 24px;
      color: $text-color;
      position: relative;
      top: -3px;

      .price {
        font-size: 34px;
        color: $primary-color;
      }
    }
  }
  .order-status {
    font-size: 22px;
    display: flex;
    justify-content: space-between;
    padding: 24px 0;

    .status {
      position: relative;
      display: flex;
      align-items: center;

      &:before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
        background-color: $primary-color;
      }
      &.end {
        color: #999;

        &:before {
          background-color: #999;
        }
      }
    }
    .rel-price {
      color: $text-color;
    }
  }
}
</style>